import { render, staticRenderFns } from "./vt-tabbed-app.vue?vue&type=template&id=7670d58a&scoped=true&"
import script from "./vt-tabbed-app.vue?vue&type=script&lang=ts&"
export * from "./vt-tabbed-app.vue?vue&type=script&lang=ts&"
import style0 from "./vt-tabbed-app.vue?vue&type=style&index=0&id=7670d58a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7670d58a",
  null
  
)

export default component.exports